import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { switchMap, tap, map } from 'rxjs/operators';
import { SortColumn, SortDirection } from '../_directives/sortable.directive';
import { State } from '../_models/State';
import { Laboratory } from '../_models/Laboratory';
import { Customers } from '../_models/Customers';

interface SearchLaboratoryResult {
  data: Laboratory[];
  total: number;
}
const compare = (v1: string, v2: string) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

function sort(data: Laboratory[], column: SortColumn, direction: string): Laboratory[] {
  if (direction === '' || column === '') {
    return data;
  } else {
    return [...data].sort((a, b) => {
      const res = compare(`${a[column]}`, `${b[column]}`);
      return direction === 'asc' ? res : -res;
    });
  }
}
function matches(data: Laboratory, term: string) {
  return data.categoryName.toLowerCase().includes(term.toLowerCase())
}

@Injectable({
  providedIn: 'root'
})
export class LaboratoryService {

  constructor(private http: HttpClient) {
  }

  private _loading$ = new BehaviorSubject<boolean>(true);
  private _search$ = new Subject<void>();
  private _allData$ = new BehaviorSubject<Laboratory[]>([]);
  private _data$ = new BehaviorSubject<Laboratory[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  public laboratory: Laboratory[];
  private _state: State = {
    page: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: '',
    sortDirection: ''
  };
  get total$() { return this._total$.asObservable(); }
  get loading$() { return this._loading$.asObservable(); }
  get page() { return this._state.page; }
  get pageSize() { return this._state.pageSize; }
  get searchTerm() { return this._state.searchTerm; }

  set page(page: number) { this._set({ page }); }
  set pageSize(pageSize: number) { this._set({ pageSize }); }
  set searchTerm(searchTerm: any) { this._set({ searchTerm }); }
  set sortColumn(sortColumn: SortColumn) { this._set({ sortColumn }); }
  set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }

  get data$() {
    return this._data$.asObservable();
  }
  get allData$() {
    return this._allData$.asObservable();
  }
  loadCustomer() {
    debugger
    return this.http.get<Customers[]>(`api/customer/alldropdown`);
  }
  loadRNo() {
    debugger
    return this.http.get<Customers[]>(`api/customer/alldropdownRNo`);
  }
  ExportList(LaboratoryID) {
    return this.http.get<Laboratory[]>(`api/Laboratory/all`);
  }
  getById(id) {
    return this.http.get<Laboratory[]>(`api/Laboratory/Laboratory/${id}`);
  }
  getDetail(registrationNo) {
    return this.http.get<Laboratory[]>(`api/Laboratory/Detail/${registrationNo}`);
  }
  uploadPDF(file: File): Observable<any> {
    debugger
    const formData: FormData = new FormData();
    formData.append('pdfFile', file, file.name);

    const url = 'http://mamjiadmin.airtechsolutions.pk/ClientApp/dist/assets/Upload/laboratory';
    return this.http.post(url, formData);
  }
  getAllData(fromDate, toDate) {
    debugger
    const url = `api/Laboratory/all/${fromDate}/${toDate}`;
    console.log(url);
    tap(() => this._loading$.next(true)),
      this.http.get<Laboratory[]>(url).subscribe(res => {
        debugger
        this.laboratory = res;
        this._data$.next(this.laboratory);
        this._allData$.next(this.laboratory);

        this._search$.pipe(
          switchMap(() => this._search()),
          tap(() => this._loading$.next(false))
        ).subscribe(result => {
          this._data$.next(result.data);
          this._total$.next(result.total);
        });

        this._search$.next();
      });
  }
  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
    this._search$.next();
  }

  private _search(): Observable<SearchLaboratoryResult> {
    const { sortColumn, sortDirection, pageSize, page, searchTerm } = this._state;

    // 1. sort
    let sortedData = sort(this.laboratory, sortColumn, sortDirection);

    //// 2. filter
    sortedData = sortedData.filter(data => matches(data, searchTerm));
    const total = sortedData.length;

    // 3. paginate
    const data = sortedData.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
    return of({ data, total });
  }

  clear() {
    // clear by calling subject.next() without parameters
    this._search$.next();
    this._data$.next(null);
    this._allData$.next(null);
    this._total$.next(null);
    this._loading$.next(null);
    this._state = {
      page: 1,
      pageSize: 10,
      searchTerm: '',
      sortColumn: '',
      sortDirection: ''
    };
  }
  insert(data) {
    debugger
    return this.http.post('api/laboratory/insert', data)
      .pipe(map(res => {

        console.log(res);
        return res;
      }));
  }
  update(updateData) {
    return this.http.post(`api/laboratory/update`, updateData)
      .pipe(map(res => {
        console.log(res);
        return res;
      }));
  }
  delete(data) {
    return this.http.post(`api/laboratory/delete`, data);
  }
}
